import React, {useState, useEffect} from 'react';
import SingleIdea from './SingleIdea';
import './OthersIdeas.css';
import FlipMove from "react-flip-move";
import {db} from './firebase';

function OthersIdeas() {

    const [addedActors, setAddedActors] = useState([]);
    const [addedZwrotAkcji, setAddedZwrotAkcji] = useState([])
    const [addedPytania, setAddedPytania] = useState([])
    



    useEffect(() => {
        //ustaw tablice addedActors
        db.collection('addedActors').orderBy('timestamp', 'desc').onSnapshot
        (snapshot => 
            setAddedActors(
              snapshot.docs.map(doc => ({
              data: doc.data()
        }))
        )
        )
        console.log('polaczone2', addedActors)
        //ustaw tablice addedZwrotAkcji
        db.collection('addedZwrotAkcji').orderBy('timestamp', 'desc').onSnapshot
        (snapshot => 
            setAddedZwrotAkcji(
              snapshot.docs.map(doc => ({
              data: doc.data()
        }))
        )
        )
        //ustaw pytania
        db.collection('addedPytania').orderBy('timestamp', 'desc').onSnapshot
        (snapshot => 
            setAddedPytania(
              snapshot.docs.map(doc => ({
              data: doc.data()
        }))
        )
        )
      }, [])


    //   tablica.sort((a, b) => (a.data.timestamp > b.data.timestamp) ? 1 : -1)

    //   const laczenieTablic = () => {
    //   const tablica = addedActors?.concat(addedZwrotAkcji, addedPytania);
  
    //   console.log('laczenie', tablica)

    //   {tablica?.map
    //     (
    //      ( element ) => {
    //          if (element!=null)
    //          {return <SingleIdea name={element.data.name} type={element.data.type} />}
    //      }
    //     )
    // }
    //   }
    
    return (
        <div className="other-ideas-and-title">
               <h2>Pomysly innych</h2>
        <div className="other-ideas">
         
            {console.log('body')}
            {/* {laczenieTablic()} */}
                {/* {tablica?.map
                    (
                     (  {data:{name, type}} ) => (
                        <SingleIdea name={name} type={type} />
                     )
                    )
                } */}
             <div className="other-ideas-actors">
                <FlipMove
                enterAnimation='fade'
                leaveAnimation='fade'>
                {addedActors?.map
                    (
                     ( {data:{name, type}} ) => (
                        <SingleIdea name={name} type={type} />
                     )
                    )
                }
                </FlipMove>
            </div>
            <div className="other-ideas-pytania">
                <FlipMove
                enterAnimation='fade'
                leaveAnimation='fade'>
                    {addedPytania?.map
                        (
                        (  {data:{name, type}} ) => (
                            <SingleIdea name={name} type={type} />
                        )
                        )
                    }
                </FlipMove>
            </div>
            <div className="other-ideas-zwrot-akcji">
            <FlipMove
                enterAnimation='fade'
                leaveAnimation='fade'>
                    {addedZwrotAkcji?.map
                        (
                        (  {data:{name, type}} ) => (
                            <SingleIdea name={name} type={type} />
                        )
                        )
                    }
                </FlipMove>
            </div>
        </div>
    </div>
    )
}

export default OthersIdeas;